import { IInfoCardExtraProps, InfoCard } from "./InfoCard";
import CountUp, { CountUpProps } from "react-countup";
import { toCurrencyFormat, toNumberFormat } from "../../utils";

interface Props extends IInfoCardExtraProps {
  title: string;
  value?: number | null;
  valueSubtitle?: React.ReactNode;
  isCurrency?: boolean;
  prefix?: string;
  suffix?: string;
}

export const CountUpInfoCard = (props: Props) => {
  const { value, isCurrency = false, prefix, suffix } = props;
  let actualValue: React.ReactNode = value;

  if (value != undefined) {
    let countUpProps: CountUpProps = {
      formattingFn: toNumberFormat,
      decimals: undefined,
      end: value,
      start: 0,
    };
    if (isCurrency) {
      countUpProps.formattingFn = toCurrencyFormat;
      countUpProps.decimals = 2;
    }
    if (prefix || suffix) {
      countUpProps.formattingFn = undefined;
      countUpProps.prefix = prefix ?? "";
      countUpProps.suffix = suffix ?? "";
    }
    actualValue = <CountUp {...countUpProps} />;
  }

  if (value === null) {
    actualValue = "N/A";
  }

  return <InfoCard {...props} value={actualValue} />;
};
